import preparedReducer from './reducer';
import { setBranchID } from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'globalContext';

export const selectors = (state) => state[SLICE_NAME];

export const actions = {
  setBranchID,
};
